import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useSelector } from "react-redux";
import { AppColors } from "../../../util/AppColors";

const FormsView = ({ forms }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  return (
    <div className="ph20">
      {(forms ?? reqDet?.forms)
        ?.filter((frm) => frm?.status)
        ?.map((frm) => (
          <div className="mt5 flex-row-ali-cen" key={frm?.petFormId}>
            <a
              href={frm?.file?.replace(/^https:/, "http:")}
              target="_blank"
              className="cursor"
            >
              <PictureAsPdfIcon
                className="imghw40"
                sx={{ color: AppColors.redBtn }}
              />
            </a>
            {/* <div className="gray-dot" />
            <a href={frm?.file} className="fs12 blue-color txt-regular ml5">
              {frm?.file}
            </a>
            <div
              className={`${
                frm?.status ? "green-back5" : "red-back2"
              } ph20 pv5 br15 wdth-max-cnt ml20`}
            >
              <Typography className="font-medium fs12 white-color">
                {frm?.status ? "Signed" : "Pending"}
              </Typography>
            </div> */}
          </div>
        ))}
    </div>
  );
};

export default FormsView;
